import { graphql, StaticQuery } from 'gatsby';
import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image";
import ReactHtmlParser from 'react-html-parser';
import SliderSettings from './SliderSettings';
import {CustomView, isMobileOnly, withOrientationChange} from 'react-device-detect';


let BannerSlider = (props) => {
  const data = props.allBlockContentImageAndText;
  const sliderDetails = {
    slidelist: [],
    centerPadding: '0',
    autoplay: true,
  };
  
  sliderDetails.slidelist = data.nodes.map((node) => (
    <div className="relative" key={node.id}>
      <CustomView condition={!isMobileOnly || props.isLandscape}>
        {(() => {
          if (node?.relationships?.field_image[0]?.localFile) {
            return (
              <GatsbyImage
                image={node?.relationships?.field_image[0]?.localFile?.childImageSharp?.gatsbyImageData} 
                alt={node?.relationships?.field_image[0]?.filename}
              />
            );
          }
        })()}
      </CustomView>

      <CustomView condition={isMobileOnly && props.isPortrait}>
        {(() => {
          if (node?.relationships?.field_mobile_image[0]?.localFile) {
            return (
              <GatsbyImage
                image={node?.relationships?.field_mobile_image[0]?.localFile?.childImageSharp?.gatsbyImageData} 
                alt={node?.relationships?.field_mobile_image[0]?.filename}
              />
            );
          }
        })()}
      </CustomView>

      <div className="banner-title">
        {(() => {
          if (node.body) {
            return (
              ReactHtmlParser(node.body.processed)
            );
          }
        })()}
      </div>
    </div>
  ));

  return (
    <div className="banner-slider section">
      <SliderSettings {...sliderDetails} />
    </div>
  );
};

BannerSlider = withOrientationChange(BannerSlider);

export default (props) => (
  <StaticQuery
    query={graphql`query SliderQuery {
  allBlockContentImageAndText(filter: {info: {ne: "Membership"}}) {
    totalCount
    nodes {
      id
      body {
        processed
      }
      relationships {
        field_image {
          filename
          localFile {
            childImageSharp {
              gatsbyImageData(
                breakpoints: [1024, 1440]
                transformOptions: {cropFocus: CENTER}
                layout: CONSTRAINED
                width: 1880
                height: 692
              )
            }
          }
        }
        field_mobile_image {
          filename
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 375
                height: 500
                breakpoints: [768]
                quality: 100
                transformOptions: {cropFocus: CENTER}
                layout: CONSTRAINED
              )
            }
          }
        }
      }
    }
  }
}
`}
    render={(data) => (
      <BannerSlider {...data} />
    )}
  />
);
